export default __webpack_public_path__ + "static/media/ic_back.060c7e62.svg";